import { render, staticRenderFns } from "./VDesigningTasksForm.vue?vue&type=template&id=7cd4d2cc&"
import script from "./VDesigningTasksForm.vue?vue&type=script&lang=ts&"
export * from "./VDesigningTasksForm.vue?vue&type=script&lang=ts&"
import style0 from "./VDesigningTasksForm.vue?vue&type=style&index=0&id=7cd4d2cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports